/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ArquivoEnviadoResponse,
  AtualizarMaterialDto,
  CriarMaterialDto,
  ErroResponse,
  ListaDeMateriaisResponse,
  MateriaisControllerEnviarArquivoBody,
  MateriaisControllerListarParams,
  MeuMaterialResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getMateriaisControllerListarUrl = (params?: MateriaisControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/materiais?${stringifiedParams}` : `/v1/materiais`
}

/**
 * @summary Lista os materiais do próprio parceiro, com status
 */
export const materiaisControllerListar = async (params?: MateriaisControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<ListaDeMateriaisResponse> => {

  return httpClient<ListaDeMateriaisResponse>(getMateriaisControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMateriaisControllerListarQueryKey = (params?: MateriaisControllerListarParams,) => {
    return [
    `/v1/materiais`, ...(params ? [params] : [])
    ] as const;
    }


export const getMateriaisControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof materiaisControllerListar>>, TError = ErroResponse>(params?: MateriaisControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materiaisControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMateriaisControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof materiaisControllerListar>>> = ({ signal }) => materiaisControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof materiaisControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MateriaisControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof materiaisControllerListar>>>
export type MateriaisControllerListarQueryError = ErroResponse


export function useMateriaisControllerListar<TData = Awaited<ReturnType<typeof materiaisControllerListar>>, TError = ErroResponse>(
 params: undefined |  MateriaisControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof materiaisControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof materiaisControllerListar>>,
          TError,
          Awaited<ReturnType<typeof materiaisControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMateriaisControllerListar<TData = Awaited<ReturnType<typeof materiaisControllerListar>>, TError = ErroResponse>(
 params?: MateriaisControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materiaisControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof materiaisControllerListar>>,
          TError,
          Awaited<ReturnType<typeof materiaisControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMateriaisControllerListar<TData = Awaited<ReturnType<typeof materiaisControllerListar>>, TError = ErroResponse>(
 params?: MateriaisControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materiaisControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os materiais do próprio parceiro, com status
 */

export function useMateriaisControllerListar<TData = Awaited<ReturnType<typeof materiaisControllerListar>>, TError = ErroResponse>(
 params?: MateriaisControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof materiaisControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMateriaisControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMateriaisControllerCriarUrl = () => {




  return `/v1/materiais`
}

/**
 * @summary Cria o material. Nasce PENDENTE — o status não vem do cliente.
 */
export const materiaisControllerCriar = async (criarMaterialDto: CriarMaterialDto, options?: Parameters<typeof httpClient>[1]): Promise<MeuMaterialResponse> => {

  return httpClient<MeuMaterialResponse>(getMateriaisControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarMaterialDto)
  }
);}





export const getMateriaisControllerCriarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materiaisControllerCriar>>, TError,{data: CriarMaterialDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof materiaisControllerCriar>>, TError,{data: CriarMaterialDto}, TContext> => {

const mutationKey = ['materiaisControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof materiaisControllerCriar>>, {data: CriarMaterialDto}> = (props) => {
          const {data} = props ?? {};

          return  materiaisControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MateriaisControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof materiaisControllerCriar>>>
    export type MateriaisControllerCriarMutationBody = CriarMaterialDto
    export type MateriaisControllerCriarMutationError = unknown

    /**
 * @summary Cria o material. Nasce PENDENTE — o status não vem do cliente.
 */
export const useMateriaisControllerCriar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materiaisControllerCriar>>, TError,{data: CriarMaterialDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof materiaisControllerCriar>>,
        TError,
        {data: CriarMaterialDto},
        TContext
      > => {
      return useMutation(getMateriaisControllerCriarMutationOptions(options), queryClient);
    }
    export const getMateriaisControllerEnviarArquivoUrl = () => {




  return `/v1/materiais/arquivo`
}

/**
 * @summary Envia o PDF e devolve o `arquivoId` para usar no material
 */
export const materiaisControllerEnviarArquivo = async (materiaisControllerEnviarArquivoBody: MateriaisControllerEnviarArquivoBody, options?: Parameters<typeof httpClient>[1]): Promise<ArquivoEnviadoResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, materiaisControllerEnviarArquivoBody.arquivo);

  return httpClient<ArquivoEnviadoResponse>(getMateriaisControllerEnviarArquivoUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getMateriaisControllerEnviarArquivoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materiaisControllerEnviarArquivo>>, TError,{data: MateriaisControllerEnviarArquivoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof materiaisControllerEnviarArquivo>>, TError,{data: MateriaisControllerEnviarArquivoBody}, TContext> => {

const mutationKey = ['materiaisControllerEnviarArquivo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof materiaisControllerEnviarArquivo>>, {data: MateriaisControllerEnviarArquivoBody}> = (props) => {
          const {data} = props ?? {};

          return  materiaisControllerEnviarArquivo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MateriaisControllerEnviarArquivoMutationResult = NonNullable<Awaited<ReturnType<typeof materiaisControllerEnviarArquivo>>>
    export type MateriaisControllerEnviarArquivoMutationBody = MateriaisControllerEnviarArquivoBody
    export type MateriaisControllerEnviarArquivoMutationError = ErroResponse

    /**
 * @summary Envia o PDF e devolve o `arquivoId` para usar no material
 */
export const useMateriaisControllerEnviarArquivo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materiaisControllerEnviarArquivo>>, TError,{data: MateriaisControllerEnviarArquivoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof materiaisControllerEnviarArquivo>>,
        TError,
        {data: MateriaisControllerEnviarArquivoBody},
        TContext
      > => {
      return useMutation(getMateriaisControllerEnviarArquivoMutationOptions(options), queryClient);
    }
    export const getMateriaisControllerAtualizarUrl = (id: string,) => {




  return `/v1/materiais/${id}`
}

/**
 * @summary Edita. Material rejeitado volta para PENDENTE; aprovado responde 409.
 */
export const materiaisControllerAtualizar = async (id: string,
    atualizarMaterialDto: AtualizarMaterialDto, options?: Parameters<typeof httpClient>[1]): Promise<MeuMaterialResponse> => {

  return httpClient<MeuMaterialResponse>(getMateriaisControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarMaterialDto)
  }
);}





export const getMateriaisControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materiaisControllerAtualizar>>, TError,{id: string;data: AtualizarMaterialDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof materiaisControllerAtualizar>>, TError,{id: string;data: AtualizarMaterialDto}, TContext> => {

const mutationKey = ['materiaisControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof materiaisControllerAtualizar>>, {id: string;data: AtualizarMaterialDto}> = (props) => {
          const {id,data} = props ?? {};

          return  materiaisControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MateriaisControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof materiaisControllerAtualizar>>>
    export type MateriaisControllerAtualizarMutationBody = AtualizarMaterialDto
    export type MateriaisControllerAtualizarMutationError = ErroResponse

    /**
 * @summary Edita. Material rejeitado volta para PENDENTE; aprovado responde 409.
 */
export const useMateriaisControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materiaisControllerAtualizar>>, TError,{id: string;data: AtualizarMaterialDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof materiaisControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarMaterialDto},
        TContext
      > => {
      return useMutation(getMateriaisControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getMateriaisControllerExcluirUrl = (id: string,) => {




  return `/v1/materiais/${id}`
}

/**
 * @summary Exclui. Aprovado responde 409 — tirar do ar é ação do admin.
 */
export const materiaisControllerExcluir = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getMateriaisControllerExcluirUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getMateriaisControllerExcluirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materiaisControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof materiaisControllerExcluir>>, TError,{id: string}, TContext> => {

const mutationKey = ['materiaisControllerExcluir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof materiaisControllerExcluir>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  materiaisControllerExcluir(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MateriaisControllerExcluirMutationResult = NonNullable<Awaited<ReturnType<typeof materiaisControllerExcluir>>>

    export type MateriaisControllerExcluirMutationError = ErroResponse

    /**
 * @summary Exclui. Aprovado responde 409 — tirar do ar é ação do admin.
 */
export const useMateriaisControllerExcluir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof materiaisControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof materiaisControllerExcluir>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getMateriaisControllerExcluirMutationOptions(options), queryClient);
    }
